import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopService } from '../../../services/shop.service';

@Component({
  selector: 'app-view-shops',
  templateUrl: './view-shops.component.html',
  styleUrls: ['./view-shops.component.css'],
  providers:[ShopService]
})
export class ViewShopsComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  shop: any = {};
  constructor(private shopService:ShopService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getShop();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getShop(){
    this.shopService.get(this.id).subscribe((shop) => {
      this.shop = shop;
    });
  }
  

  saveShop(){
    if (this.shop.id == undefined){
      this.shopService.create(this.returnShopProperties(this.shop))
      .subscribe((productRam) => {
        this.shopService.get(productRam.id).subscribe((shop) => {
          this.shop = shop;
          this.router.navigate(['/configuration/shops']);
        });
      });
    }else{
      this.shopService.update(this.returnShopProperties(this.shop))
      .subscribe((shop) => {
        this.shop = shop;
        this.router.navigate(['/configuration/shops']);
      });
    }
  }

  returnShopProperties(shop){
    var properties = {
      name: shop.name,
      address: shop.address,
      telephone: shop.telephone
    }
    if (shop.id){
      properties['id'] = shop.id;
    }
    return properties;
  }


}



// WEBPACK FOOTER //
// ./src/app/configuration/components/shops/view-shops/view-shops.component.ts